import { React } from "react";
import DatePicker from "react-datepicker";

import "../index.css";
import "react-datepicker/dist/react-datepicker.css";

export default function FormPremisesDetails(props) {
  const form = props.form;
  const premisesErrors = props.premisesErrors;
  const setPremisesErrors = props.setPremisesErrors;

  const onSubmitHandler = async () => {
    const postCodeRegex = new RegExp(/^[0-9]+$/);
    const numericRegex = new RegExp(/^([0-9]+\.?[0-9]*|\.[0-9]+)$/);

    const errors = {};

    if (form.premises_address_line_1.trim() === "") {
      errors.premises_address_line_1 = "Address Line 1 cannot be empty";
    }

    if (form.premises_address_line_1.trim().length < 4) {
      errors.premises_address_line_1 = "Address Line 1 cannot be less than 4 characters";
    }

    if (form.premises_suburb.trim() === "") {
      errors.premises_suburb = "Suburb cannot be empty";
    }

    if (form.premises_suburb.trim().length < 2) {
      errors.premises_suburb = "Suburb cannot be less than 2 characters";
    }

    if (!postCodeRegex.test(form.premises_postcode)) {
      errors.premises_postcode = "Postcode must be numeric";
    }
    if (form.premises_postcode.trim() === "") {
      errors.premises_postcode = "Postcode cannot be empty";
    }

    if (form.lease_start_date === "") {
      errors.lease_start_date = "Lease start date cannot be empty";
    }

    if (form.rent_amount === "") {
      errors.rent_amount = "Rent amount cannot be empty";
    }

    if (!numericRegex.test(form.rent_amount)) {
      errors.rent_amount = "Rent amount must be numeric";
    }

    if (form.fixed_term === "") {
      errors.fixed_term = "Fixed period term cannot be empty";
    }

    if (!numericRegex.test(form.fixed_term)) {
      errors.fixed_term = "Fixed period term must be numeric";
    }

    setPremisesErrors(errors);

    if (Object.keys(errors).length === 0) {
      handleDate(form.lease_start_date);
      props.handleProductSelection(form.type);
    }
  };

  const handleDate = (date) => {
    props.setForm((form) => {
      return {
        ...form,
        lease_start_date: date
      };
    });
  };

  return (
    <div>
      <h4 className="text-2xl font-semibold">Premises Details</h4>
      <p className="leading-relaxed mt-1 text-gray-600 mb-10">
        Enter the premises details for which the form is being created.
      </p>

      <form className="space-y-4 xs:w-[100%]">
        <div className="flex flex-wrap">
          <div className="w-full">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="premises_address_line_1"
            >
              Address Line 1 <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className={
                premisesErrors.premises_address_line_1
                  ? " border-red-500 border-x border-y px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
              required
              placeholder="Address Line 1"
              name="premises_address_line_1"
              onChange={props.handleChange("premises_address_line_1")}
              defaultValue={form.premises_address_line_1}
            />
            <p className=" text-red-600 text-xs mt-2">
              {premisesErrors.premises_address_line_1}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div className="w-full px-2">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="premises_address_line_2"
            >
              Address Line 2
            </label>
            <input
              type="text"
              className="border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              placeholder="Address Line 2"
              name="premises_address_line_2"
              onChange={props.handleChange("premises_address_line_2")}
              defaultValue={form.premises_address_line_2}
            />
          </div>
        </div>
        <div className="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div className="w-full px-2 md:w-1/2">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="premises_suburb"
            >
              Suburb <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className={
                premisesErrors.premises_suburb
                  ? " border-red-500 border-x border-y px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
              placeholder="Suburb"
              name="premises_suburb"
              onChange={props.handleChange("premises_suburb")}
              defaultValue={form.premises_suburb}
            />
            <p className=" text-red-600 text-xs mt-2">
              {premisesErrors.premises_suburb}
            </p>
          </div>
          <div className="w-full px-2 md:w-1/4">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="premises_state"
            >
              State
            </label>
            <input
              disabled={true}
              type="text"
              className="border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              name="premises_state"
              defaultValue={form.premises_state}
            />
          </div>
          <div className="w-full px-2 md:w-1/4">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="premises_postcode"
            >
              Postcode <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              maxLength={4}
              className={
                premisesErrors.premises_postcode
                  ? " border-red-500 border-x border-y px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
              placeholder="Postcode"
              name="premises_postCode"
              onChange={props.handleChange("premises_postcode")}
              defaultValue={form.premises_postcode}
            />
            <p className=" text-red-600 text-xs mt-2">
              {premisesErrors.premises_postcode}
            </p>
          </div>
        </div>

        <div className="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div className="w-full px-2 md:w-1/2">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="premises_postcode"
            >
              Lease Start Date <span className="text-red-500">*</span>
            </label>

            <DatePicker
              calendarClassName="bg-yellow-400"
              selected={form.lease_start_date}
              value={form.lease_start_date}
              placeholderText="DD/MM/YYYY"
              allowSameDay={true}
              dateFormat="dd/MM/yyyy"
              onChange={handleDate}
              className={
                premisesErrors.lease_start_date
                  ? "border-red-500 border-x border-y"
                  : ""
              }
            />

            <p className=" text-red-600 text-xs mt-2">
              {premisesErrors.lease_start_date}
            </p>
          </div>

          <div className="w-full px-2 md:w-1/2">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
            >
              Lease Period <span className="text-red-500 mr-1">*</span><span className="normal-case">(months)</span>
            </label>
            <input
              type="text"
              className={
                premisesErrors.fixed_term
                  ? " border-red-500 border-x border-y px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
              placeholder="12"
              name="fixed_term"
              onChange={props.handleChange("fixed_term")}
              defaultValue={form.fixed_term}
            />
            <p className=" text-red-600 text-xs mt-2">
              {premisesErrors.fixed_term}
            </p>
          </div>


        </div>

        <div className="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div className="w-full px-2 md:w-1/2">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="premises_suburb"
            >
              Rent Amount <span className="text-red-500 mr-1">*</span>
            </label>
            <input
              type="text"
              className={
                premisesErrors.rent_amount
                  ? " border-red-500 border-x border-y px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
              placeholder="500.00"
              name="rent_amount"
              onChange={props.handleChange("rent_amount")}
              defaultValue={form.rent_amount}
            />
            <p className=" text-red-600 text-xs mt-2">
              {premisesErrors.rent_amount}
            </p>
          </div>

          <div className="w-full px-2 md:w-1/2">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="rent_frequency"
            >
              Rent Frequency  <span className="text-red-500">*</span>
            </label>
            <select
              onChange={props.handleChange("rent_frequency")}
              className="border-0 px-3 py-3 text-gray-700 rounded text-xs shadow focus:outline-none focus:ring w-full"
              defaultValue={form.rent_frequency}
            >
              <option value="Week">Weekly</option>
              <option value="Fortnight">Fortnightly</option>
              <option value="Month">Monthly</option>
              <option value="Quarter">Quarterly</option>
            </select>
          </div>


        </div>
      </form>

      <div className="text-center flex justify-between mt-6">
        <button
          className="text-white bg-black focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
          type="button"
          onClick={props.prevStep}
        >
          Back
        </button>

        <button
          className="text-white bg-[#3059a9] focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
          type="button"
          onClick={onSubmitHandler}
        >
          Next
        </button>
      </div>
      <p
        className={
          props.unexpectedError ? "text-red-600 text-s mt-2" : "hidden"
        }
      >
        {props.unexpectedError.message}
      </p>
    </div>
  );
}
